<div *ngIf="factors" class="row justify-content-center">
    
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Factores Terman</h4>
            </div>
            <div class="card-body">
                
                <h3 class="card-title">Listado de valores</h3>
                <hr>
                    <div *ngFor="let factor of factors" class="form-body">
                            
                        <div class="col-md-12 text-center">
                            <h2 *ngIf="factor.serie=='informacion'">SERIE I: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='juicio'">SERIE II: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='vocabulario'">SERIE III: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='sintesis'">SERIE IV: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='Concentración'">SERIE V: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='analisis'">SERIE VI: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='abstraccion'">SERIE VII: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='planeacion'">SERIE VIII: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='organizacion'">SERIE IX: {{factor.serie.toUpperCase()}}</h2>
                            <h2 *ngIf="factor.serie=='atencion'">SERIE X: {{factor.serie.toUpperCase()}}</h2>
                        </div>

                        <div *ngFor="let r of factor.rank" class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Rango: {{r.low}} - {{r.high}}: {{r.title}}</h3>
                                    <p>{{r.description}}</p>
                                </div>
                            </div>

                        </div>

                        <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>

                        <hr>
                    </div>
                    
                
            </div>
        </div>
    </div>
</div>